import eBillHomeApi from '@/api/eBillHome/eBillHomeApi.js';

export default {
	name: 'e-bill-cancel',
	mixins: [],
	extends: {},
	components: {},
	props: ['applyOption', 'applyText'],
	data() {
		return {};
	},
	computed: {

	},
	watch: {},
	created() {
	},
	mounted() {},
	updated() {},
	beforeDestroy() {},
	methods: {
		async cancelEBill(){
			let result = await eBillHomeApi.changeEBillType(this.$store.state.profile.mdn, '0', '', '');
			if(result){
				this.$router.push({ name: 'e-bill-cancel-result'});
				return;
			}
		}
	},
};



// WEBPACK FOOTER //
// ./src/components/eBill/eBillCancel/eBillCancel.js